import { ModelType } from 'graphql-ts-client-api'
import { query$, authenticationGraphDbContext$ } from '../__generated/media-store/fetchers'
import { userRoleExtend$$, userRoleExtendPage$ } from '../__generated/media-store/fetchers'

const UserRolesSelector = userRoleExtend$$

export type TUserRole = ModelType<typeof UserRolesSelector>

export type TRolesFilterParams = Parameters<typeof authenticationGraphDbContext$.userRoles>[0]

export const UserRolesQuery = (params: TRolesFilterParams) => {
  const RolePage = userRoleExtendPage$.items(UserRolesSelector).hasNextPage.hasPreviousPage.totalItems
  return query$.auth(authenticationGraphDbContext$.userRoles(params, RolePage))
}
